export default __webpack_public_path__ + "static/media/w_f_2019_a.68c81936.jpg";